import { useDroppable } from '@dnd-kit/core';

const GroupDroppable = ({ id, isActive = false, children }) => {
    const { setNodeRef } = useDroppable({
        id: id,
        data: { type: 'dragGroup', isActive: isActive }
    });
    return (
        <div
            ref={setNodeRef}
            style={{
                height: '100%',
                zIndex: 11
                //position: 'relative' /* width: '100%' */
            }}
        >
            {children}
        </div>
    );
};

export default GroupDroppable;
